let group = {
    name: ''
};

export  default group;